import { jsx as _jsx } from "react/jsx-runtime";
import { Cell } from "../cell/cell";
function SummaryCell({ index, children, colSpan = 1, rowSpan, align, }) {
    return (_jsx(Cell, { sortIcon: false, index: index, align: align, colSpan: colSpan, render: () => ({
            children,
            props: {
                colSpan,
                rowSpan,
            },
        }) }));
}
export { SummaryCell };
